var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "no-data", style: { height: _vm.height, width: _vm.width } },
    [
      _c("img", {
        style: { height: "90%", width: "90%" },
        attrs: { src: require("../../assets/nodata.svg"), alt: "" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }